import { render, staticRenderFns } from "./shinsotsu.vue?vue&type=template&id=7440bb60&"
import script from "./shinsotsu.vue?vue&type=script&lang=js&"
export * from "./shinsotsu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports